(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kz-editorial-home"] && !Shopify.designMode) return;
  try {
    
function kzInitFilters(root){root.querySelectorAll('.kz-shop').forEach(shop=>{if(shop.dataset.kzReady)return;shop.dataset.kzReady='true';shop.querySelectorAll('[data-kz-filter]').forEach(button=>button.addEventListener('click',()=>{shop.querySelectorAll('[data-kz-filter]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));shop.querySelectorAll('[data-kz-kind]').forEach(card=>{card.hidden=button.dataset.kzFilter!=='all'&&!card.dataset.kzKind.split(/\s+/).includes(button.dataset.kzFilter);});}));const initial=new URLSearchParams(window.location.search).get('kz_filter');if(initial){const initialButton=shop.querySelector('[data-kz-filter="'+initial+'"]');if(initialButton)initialButton.click();}});}kzInitFilters(document);document.addEventListener('shopify:section:load',event=>kzInitFilters(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
